import React from 'react';
import {connect} from "react-redux";
import Button from "../../../../../../../../../../../../components/button";
import {contactContent} from "../../../../../../../../../../../../../actions/contactDetailsActions";
import {contactDetailsEditMode} from "../../../../../../../../../../../../../actions/contactActions";
import './index.css';

function ContactInfoCommentBtn (props) {

    const {
        findComments,
        setContactContent,
        sharingDetailsPopup,
        contactDetailsEditMode,
        findContactDetails,
        selectedContactsGroup
    } = props;

    const handleClick = () => {
        if(sharingDetailsPopup.length > 0) {
            setContactContent("comments");
        } else {
            contactDetailsEditMode(false);
        }
    };

    return (
        <Button className="contact-info-comment-btn btn-link p-0" onClick={handleClick} disabled={selectedContactsGroup === null || findContactDetails.commentable === false || (selectedContactsGroup && selectedContactsGroup.directorySyncStatus === 'RUNNING')}>
            <svg width="32" height="36" viewBox="0 0 32 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M3.92293 16.1192C3.75 16.9886 3.75 18.0341 3.75 20.125V20.5C3.75 22.9402 3.75 24.1604 3.98511 25.1687C4.76325 28.506 7.36905 31.1118 10.7063 31.8899C11.7146 32.125 12.9348 32.125 15.375 32.125H20.625C23.0906 32.125 24.3234 32.125 25.1532 31.444C25.3051 31.3194 25.4444 31.1801 25.569 31.0282C26.25 30.1984 26.25 28.9656 26.25 26.5V20.125C26.25 18.0341 26.25 16.9886 26.0771 16.1192C25.3669 12.549 22.576 9.75809 19.0058 9.04793C18.1364 8.875 17.0909 8.875 15 8.875C12.9091 8.875 11.8636 8.875 10.9942 9.04793C7.42397 9.75809 4.63309 12.549 3.92293 16.1192ZM10.25 19.2083C10.25 18.656 10.6977 18.2083 11.25 18.2083H18.75C19.3023 18.2083 19.75 18.656 19.75 19.2083C19.75 19.7606 19.3023 20.2083 18.75 20.2083H11.25C10.6977 20.2083 10.25 19.7606 10.25 19.2083ZM14 24.375C14 23.8227 14.4477 23.375 15 23.375H18.75C19.3023 23.375 19.75 23.8227 19.75 24.375C19.75 24.9273 19.3023 25.375 18.75 25.375H15C14.4477 25.375 14 24.9273 14 24.375Z" fill="#314D60"/>
                <circle cx="24" cy="8" r="8" fill={findComments ? findComments.commentResponses.length > 0 ? '#4CBEA3' : '#BEBEBE' : '#BEBEBE'}/>
                <text x="24" y="13" textAnchor="middle" style={{fontWeight: 'normal', fontSize: '12px', fill: '#fff'}}>{findComments ? findComments.pagesInfo.totalRecords : '0'}</text>
            </svg>
        </Button>
    )
}

const mapStateToProps = (state) => {
    return {
        findComments: state.commentReducer.findComments,
        sharingDetailsPopup: state.sharingDetailsReducer.getSharingDetailsPopup,
        findContactDetails: state.contactDetailsReducer.findContactDetails,
        selectedContactsGroup: state.contactsGroupItemReducer.getSelectedContactsGroup
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        setContactContent : (string) => {
            dispatch(contactContent(string))
        },
        contactDetailsEditMode : (boolean) => {
            dispatch(contactDetailsEditMode(boolean))
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ContactInfoCommentBtn);
